export default "__VITE_ASSET__4102f712__"